// extracted by mini-css-extract-plugin
export default {"container":"UVgMV","container--m":"zIABj","container--light-grey":"yRvz6"};